<template>
  <div class="container video-block">
    <video
      :src="moduleData.settings.src || ''"
      v-observe-visibility="{
        callback: visibilityChanged,
        intersection: { threshold: 0.2 }
      }"
      :loop="moduleData.settings.loop == true ? 'loop' : false"
      muted="true"
      playsinline
      preload="auto"
    />
  </div>
</template>

<script>
// :controls="moduleData.settings.trigger == 'controls' ? true : false"


import Vue from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
Vue.directive('observe-visibility', ObserveVisibility)
export default {
  props: {
    moduleData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.moduleData.settings.trigger === 'controls') {
        return
      }
      // console.log(entry)
      if (isVisible) {
        entry.target.play()
      } else {
        entry.target.pause()
        entry.target.currentTime = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
video {
  width: 100%;
}
</style>